import React, { FC } from 'react';
import clsx from 'clsx';
import { Dialog, Modal } from '@material-ui/core';
import './ModalComponent.scss';

interface ModalProps {
  showCloseButton?: boolean;
  open: boolean;
  setOpen: (open: boolean) => void;
  title?: string;
  className?: string;
  children: React.ReactNode;
}

export const DialogComponent: FC<ModalProps> = ({
  showCloseButton,
  open,
  setOpen,
  title,
  className,
  children,
}) => {
  // Only keep the spacing for top bar if needed
  const topBar = title || showCloseButton;

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth={false}>
      <div className={clsx('new-dialog', className)} id="modal-component">
        {topBar && (
          <div className="new-dialog__top">
            <h1>{title}</h1>
            {showCloseButton && (
              <span
                className="new-dialog__top__close"
                onClick={() => setOpen(false)}
              >
                +
              </span>
            )}
          </div>
        )}
        {children}
      </div>
    </Dialog>
  );
};

const ModalComponent = ({
  showCloseButton,
  title,
  open,
  setOpen,
  className,
  children,
}: ModalProps): JSX.Element => {
  // Only keep the spacing for top bar if needed
  const topBar = title || showCloseButton;

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <div className={clsx('new-modal', className)} id="modal-component">
        {topBar && (
          <div className="new-modal__top">
            <h1>{title}</h1>
            {showCloseButton && (
              <span
                className="new-modal__top__close"
                onClick={() => setOpen(false)}
              >
                +
              </span>
            )}
          </div>
        )}
        {children}
      </div>
    </Modal>
  );
};

export default ModalComponent;
